import React from 'react';
import type { IconProps } from '../types';

export const LuxmedLogo = (props: IconProps) => (
  <img
    src="/assets/LUXMED_LOGO.png"
    alt="LUXMED Logo"
    className="h-18 w-18"
    {...props}
  />
);

export default LuxmedLogo;
